import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  tabContext: css`
    display: flex;
    flex-direction: column;
    padding: 24px 16px 16px;

    height: 100%;
    width: 100%;
  `,
  tabButtonGroup: css`
    display: flex;
    align-items: center;
  `,
  tabButton: ({ theme }) => css`
    flex: unset;
    padding: 6px 12px;
    height: auto;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    gap: 8px;
    flex-shrink: 0;

    &,
    &:hover,
    &[data-state='active'] {
      color: ${theme.colors.neutral.variant[60]};
      font-weight: 400;
    }

    svg {
      flex-shrink: 0;
    }
  `,
  tabPanelGroup: ({ theme }) => css`
    display: flex;
    margin-top: 8px;
    height: 100%;

    border-top: solid 1px ${theme.colors.neutral.variant[30]};
  `,
  tabPanel: css`
    display: flex;
    padding: 16px 0 0;
    flex-direction: column;
    overflow: hidden;

    width: 100%;
    height: 100%;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
